module.exports = __webpack_public_path__ + "img/icon_skype_white.1f4ff84.svg";